








































































































// @ts-nocheck
import Vue from 'vue';
import { DetailStore } from '@/store/index';
import { FitHalfScreenDialog, FitButton } from '@/fit-ui';
import func from 'vue-temp/vue-editor-bridge';

export default Vue.extend({
  name: 'PayDialog',
  data() {
    return {
      DetailStore,
    };
  },
  activated() {
  },
  mounted() {
  },
  watch: {
    'DetailStore.tencentCharityTipsShow'(newVal) {
      if (newVal) {
        this.disableBodyScroll();
      }
    },
  },
  methods: {
    handleDialogClose() {
      this.enableBodyScroll();
      DetailStore.tencentCharityTipsShow = false;
    },
    disableBodyScroll() {
      document.body.style.overflow = 'hidden';
    },
    enableBodyScroll() {
      document.body.style.overflow = 'auto';
    },
  },
  components: {
    FitHalfScreenDialog,
    FitButton,
  },
});
